import { IcoLogo } from "~/icons";
import { Link, useLocation } from "@remix-run/react";
import { useWindowWidth } from "~/utils/hooks/useWindowWidth";
import classNames from "classnames";
import { useEffect, useState } from "react";

const Footer = () => {
  const location = useLocation();
  const { pathname } = location;
  const landingsURL = [
    "/promo",
    "/shereadsromancebooks",
    "/smartbitchestrashybooks",
  ];
  const targetPath =
    pathname === "/about" || landingsURL.includes(pathname) ? pathname : "/";
  const width = useWindowWidth();
  const handleClickOnManageCookies = () => {
    localStorage.removeItem("TERMLY_API_CACHE");
    window.location.reload();
  };
  const [isFixed, setIsFixed] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const booksSection = document.querySelector(".books");
      if (!booksSection) return;

      const blocks = booksSection.querySelectorAll(".books__items");
      if (blocks.length < 6) return;

      const sixthBlock = blocks[5];
      const rect = sixthBlock.getBoundingClientRect();

      setIsFixed(rect.top < 0);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const isCatalogPage = pathname === "/";

  return (
    <footer
      className={classNames(
        "max-md:py-4 py-8",
        isCatalogPage &&
          isFixed &&
          "fixed bottom-0 left-0 w-full bg-[#091227] z-10 shadow-custom-drop",
      )}
    >
      <div className="container">
        <div className="max-md:flex-wrap flex justify-between items-center">
          <div className="max-md:block max-md:w-full flex items-center">
            <Link
              to={targetPath}
              className={classNames(width < 768 && "flex justify-center mb-2")}
            >
              <IcoLogo
                width={width > 768 ? 122 : 92}
                height={width > 768 ? 60 : 43}
              />
            </Link>

            <div className="max-md:ml-0 ml-6">
              <div className="max-md:flex max-md:justify-center max-md:flex-wrap max-md:text-center text-white font-semibold leading-[26px]">
                Contact us:{" "}
                <a
                  className="max-md:w-full hover:underline"
                  href="mailto:help@wromance.com"
                >
                  help@wromance.com
                </a>
              </div>
              <div className="max-md:text-center text-white opacity-70 text-sm leading-[26px]">
                Womanly Corp. 8 THE GREEN, STE ADOVER DE 19901
              </div>
            </div>
          </div>
          <div className="max-md:w-full">
            <ul className="max-md:w-full max-md:mt-4 flex max-md:justify-between">
              <li>
                <Link
                  className="max-md:mr-0 max-md:text-xs font-semibold text-white leading-[26px] mr-8 hover:underline"
                  to="/cookie_policy"
                  target="_blank"
                >
                  Cookie Policy
                </Link>
              </li>
              <li>
                <button
                  className="max-md:mr-0 max-md:text-xs font-semibold text-white leading-[26px] hover:underline mr-8"
                  onClick={handleClickOnManageCookies}
                >
                  Cookie preferences
                </button>
              </li>
              <li>
                <Link
                  className="max-md:mr-0 max-md:text-xs font-semibold text-white leading-[26px] mr-8 hover:underline"
                  to="/privacy_policy"
                  target="_blank"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  className="max-md:mr-0 max-md:text-xs font-semibold text-white leading-[26px] hover:underline"
                  to="/terms_and_conditions"
                  target="_blank"
                >
                  Terms
                </Link>
              </li>
            </ul>
            <div className="max-md:mt-2 max-md:text-left mt-3 text-[#87B7FF] leading-[22px] text-[10px] text-right">
              @2025 Womanly Corp
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

Footer.displayName = "Footer";

export default Footer;
